import styled from '@emotion/styled';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: calc(100vh - 80px);
  overflow-y: auto;
`;

export const CurrentPositionContainer = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 24px;
  width: 100%;
  height: fit-content;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin-bottom: 24px;
`;

export const TimelineContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-bottom: 48px;
  
  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #F1F5F9;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #CBD5E1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #94A3B8;
  }
`; 